/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'component': {
    width: 64,
    height: 64,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M64 64h384v384H64V64zm0 512h384v384H64V576zm512 0h384v384H576V576zm192-128c106.039 0 192-85.961 192-192S874.039 64 768 64s-192 85.961-192 192 85.961 192 192 192z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/component.js